import apiRequest from './apiRequest';
import * as routerDom from 'react-router-dom';
const { defer } = routerDom;

export const singlePageLoader = async ({ request, params }) => {
  const res = await apiRequest('/posts/' + params.id);
  return res.data;
};

export const listPageLoader = async ({ request, params }) => { 
  const query = request.url.split('?')[1]; 
  const postPromise = apiRequest('/posts?' + query); 
  return { postResponse: postPromise, }; 
};

export const categoryPageLoader = async ({ request, params }) => {
  const queryParams = new URLSearchParams(request.url.includes('?') ? request.url.split('?')[1] : '');

  // Добавляем `selectedOptions` в `queryParams`
  Object.entries(params.selectedOptions || {}).forEach(([key, value]) => {
    if (value) queryParams.set(key, value.value);
  });

  const queryString = queryParams.toString();
  const postResponse = await apiRequest(`/posts?${queryString}`);

  return {
    postResponse,
  };
};

// Проверяем, есть ли параметр запроса, прежде чем использовать его.
export const latestAdsLoader = async ({ request, params }) => {
  const query = request.url.includes('?') ? request.url.split('?')[1] : '';
  const postPromise = apiRequest('/posts?' + query);

  // Дожидаемся выполнения запроса, чтобы вернуть конкретные данные
  const postResponse = await postPromise;

  return {
    postResponse,
  };
};

export const editPostPageLoader = async ({ request, params }) => {
  const res = await apiRequest('/posts/' + params.id);
  return res.data;
};

export const profilePageLoader = async () => {
  const postPromise = apiRequest('/users/profilePosts');
  const chatPromise = apiRequest('/chats');
  return {
    postResponse: postPromise,
    chatResponse: chatPromise,
  };
};

export const favoritePageLoader = async ({ request, params }) => {
  try {
    const postPromise = apiRequest('/users/profilePosts'); 

    const data = {
      postResponse: postPromise,
    };

    return typeof routerDom.defer === 'function'
      ? routerDom.defer(data)
      : data;
  } catch (err) {
    console.error('Failed to load favorite posts:', err);
    throw new Error('Failed to load favorite posts');
  }
};

export const chatsPageLoader = async () => {
  const token = JSON.parse(localStorage.getItem("user"))?.token || "";

  try {
    // Запрос чатов сразу
    const chatPromise = apiRequest.get('/chats', {
      headers: { Authorization: `Bearer ${token}` },
    });

    // Промис для получения postIds после чатов — оборачиваем в функцию
    const postPromise = chatPromise.then(chatRes => {
      const chatData = chatRes?.data || [];
      const postIds = chatData.map(chat => chat.postId).filter(Boolean);
      const idsParam = postIds.length ? `?ids=${postIds.join(',')}` : '';

      return apiRequest.get(`/posts${idsParam}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
    });

    // Возвращаем оба промиса — они отложены и будут загружены в компоненте
    const data = {
      chatResponse: chatPromise.then(res => res?.data || []),
      postResponse: postPromise.then(res => res?.data || []),
    };

    return typeof defer === 'function' ? defer(data) : data;

  } catch (error) {
    console.error('❌ Ошибка загрузки:', error);

    return typeof defer === 'function'
      ? defer({ chatResponse: [], postResponse: [] })
      : { chatResponse: [], postResponse: [] };
  }
};
